import { Card, Col, Row, Skeleton, Typography } from "antd";
import SanitizeHTML from "components/SanitizeHTML/SanitizeHTML";
import useViewport from "components/UseViewport/UseViewport";
import { Company } from "interfaces/companies";
import React from "react";
import { useHistory } from "react-router-dom";
import { StyledCompanyLogo, StyledHr, StyledTitle } from "./style";

const { Text } = Typography;

interface Props {
  company: Company;
}

const AboutCompany: React.FC<Props> = ({ company }) => {
  const { width } = useViewport();
  const breakpoint = 768;
  const history = useHistory();

  return (
    <>
      <Card
        bodyStyle={{ padding: "2em", cursor: "pointer", width: "100%" }}
        onClick={() => history.push(`/companies/${company.id}`)}
      >
        <Row>
          <StyledTitle level={3}>Om {company?.name}</StyledTitle>
        </Row>
        <Row justify="start">
          <StyledHr />
        </Row>

        <Row>
          <Col lg={4} md={6} sm={24} xs={24} style={width < breakpoint ? { height: "150px" } : {}}>
            {company ? (
              <StyledCompanyLogo
                size="90%"
                companyId={company.id}
                src={company.logo}
                style={width < breakpoint ? { margin: "auto" } : {}}
              />
            ) : (
              <Skeleton.Image />
            )}
          </Col>
          <Col lg={20} md={18} sm={24} xs={24}>
            {company ? (
              <Text>
                <SanitizeHTML html={company?.description ?? ""} />
              </Text>
            ) : (
              <Skeleton active />
            )}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default AboutCompany;
